import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { TranslateService } from '@ngx-translate/core';
import { ActiveTab, TabService } from '../../services/tab-service.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss']
})
export class CookieConsentComponent implements OnInit {
  showBanner = false;

  functional = false;
  analytics = false;
  marketing = false;
  privacyLink = ['/','en','privacy-policy'];
  ACTIVE_TAB = ActiveTab;
  activeTab!: ActiveTab;
  henterPantMode = false;

  constructor(
    private consent: CookieConsentService,
    private modalService: NgxSmartModalService,
    private translate: TranslateService,
    private tabService: TabService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.showBanner = !this.consent.hasMadeChoice();
    this.updatePrivacyLink();

    this.tabService.activeTab$.subscribe(tab => {
      this.activeTab = tab;
      this.henterPantMode = tab === ActiveTab.HENTERPANT;
      this.updatePrivacyLink();
    });

    this.translate.onLangChange.subscribe(() => this.updatePrivacyLink());
  }

  private updatePrivacyLink(): void {
    const lang = this.translate.currentLang || 'en';
    this.privacyLink = ['/', lang, 'privacy-policy'];
    if (this.tabService.currentTab === ActiveTab.HENTERPANT) {
      this.privacyLink = ['/', lang, 'henter-pant', 'privacy-policy'];
    }
  }

  allowAll(): void {
    this.consent.acceptAll();
    this.showBanner = false;
  }

  useOnlyNecessary(): void {
    this.consent.acceptOnlyNecessary();
    this.showBanner = false;
  }

  openManage(): void {
    const existing = this.consent.getConsent();
    this.showBanner = false;
    this.functional = !!existing?.categories.functional;
    this.analytics = !!existing?.categories.analytics;
    this.marketing = !!existing?.categories.marketing;
    this.modalService.get('cookieManageModal')?.open();
  }

  saveManage(): void {
    this.consent.save({
      necessary: true,
      functional: this.functional,
      analytics: this.analytics,
      marketing: this.marketing
    });
    // Recompute visibility from consent to avoid lingering overlay after reload
    this.showBanner = !this.consent.hasMadeChoice();
    this.modalService.get('cookieManageModal')?.close();
  }

  modalClosed(): void {
    this.showBanner = !this.consent.hasMadeChoice();
  }
}


